import React, { useContext, useRef, useState } from 'react'
import './Navbar.css'
import { Link } from 'react-router-dom'
import logo from '../Assets/logo.png'
import cart_icon from '../Assets/cart_icon.png'
import { ShopContext } from '../../Context/ShopContext'
import nav_dropdown from '../Assets/nav_dropdown.png'

const Navbar = () => {

  let [menu,setMenu] = useState("shop");
  const {getTotalCartItems} = useContext(ShopContext);

  const menuRef = useRef();

  const dropdown_toggle = (e) => {
    menuRef.current.classList.toggle('nav-menu-visible');
    e.target.classList.toggle('open');
  }

  return (
    <div className='nav'>
      <Link to='/' onClick={()=>{setMenu("shop")}} style={{ textDecoration: 'none' }} className="nav-logo">
        <img src={logo} alt="logo" />
        <p>FREECYCLE</p>
      </Link>
      <img onClick={dropdown_toggle} className='nav-dropdown' src={nav_dropdown} alt="" />
      <ul ref={menuRef} className="nav-menu">
        <li onClick={()=>{setMenu("shop")}}><Link to='/' style={{ textDecoration: 'none' }}>BUY</Link>{menu==="shop"?<hr/>:<></>}</li>
        <li onClick={() => setMenu("sell")}><Link to='/sell' style={{ textDecoration: 'none' }}>SELL</Link>{menu === "sell" ? <hr /> : <></>}</li>
        <li onClick={()=>{setMenu("cycles")}}><Link to='/cycles' style={{ textDecoration: 'none' }}>Cycles</Link>{menu==="cycles"?<hr/>:<></>}</li>
        <li onClick={()=>{setMenu("study")}}><Link to='/study' style={{ textDecoration: 'none' }}>Study Materials</Link>{menu==="study"?<hr/>:<></>}</li>
        <li onClick={()=>{setMenu("electronics")}}><Link to='/electronics' style={{ textDecoration: 'none' }}>Electronics</Link>{menu==="electronics"?<hr/>:<></>}</li>
        <li onClick={()=>{setMenu("sports")}}><Link to='/sports' style={{ textDecoration: 'none' }}>Sports</Link>{menu==="sports"?<hr/>:<></>}</li>
        <li onClick={()=>{setMenu("clothes")}}><Link to='/clothes' style={{ textDecoration: 'none' }}>Clothes</Link>{menu==="clothes"?<hr/>:<></>}</li>
        <li onClick={()=>{setMenu("others")}}><Link to='/others' style={{ textDecoration: 'none' }}>Others</Link>{menu==="others"?<hr/>:<></>}</li>
  
        
      </ul>
      <div className="nav-login-cart">
        {localStorage.getItem('auth-token')
        ?<button onClick={()=>{localStorage.removeItem('auth-token');window.location.replace("/");}}>Logout</button>
        :<Link to='/login' style={{ textDecoration: 'none' }}><button>Login</button></Link>}
        <Link to="/cart"><img src={cart_icon} alt="cart"/></Link>
        <div className="nav-cart-count">{getTotalCartItems()}</div>
      </div>
    </div>
  )
}

export default Navbar
